import { Injectable, REQUEST_CONTEXT, inject } from '@angular/core';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, ROUTES, Router } from '@angular/router';

import { VnRequestContext } from '@frontend/vanilla/ssr';

import { OnAppInit } from '../bootstrap/bootstrapper.service';
import { Page } from '../client-config/page.client-config';
import { LoadingIndicatorHandler } from '../loading-indicator/loading-indicator-handler';
import { LoadingIndicatorService } from '../loading-indicator/loading-indicator.service';
import { RouteProcessorService } from './route-processor.service';

@Injectable()
export class RoutingBootstrapService implements OnAppInit {
    private readonly router = inject(Router);
    private readonly loadingIndicatorService = inject(LoadingIndicatorService);
    private readonly routeProcessorService = inject(RouteProcessorService);
    private readonly routes = inject(ROUTES);

    private handlersByNavigationId = new Map<number, LoadingIndicatorHandler>();
    private requestContext = inject<VnRequestContext>(REQUEST_CONTEXT);
    private page = inject(Page);

    onAppInit() {
        this.requestContext?.logger?.info?.({ config: [...this.router.config], routes: this.routes, page: this.page }, 'router config before reset');
        this.router.resetConfig(this.routeProcessorService.processRoutes(this.routes));
        this.requestContext?.logger?.info?.({ config: [...this.router.config], routes: this.routes, page: this.page }, 'router config after reset');
        this.router.events.subscribe((e) => {
            if (e instanceof NavigationStart) {
                const handler = this.loadingIndicatorService.start({
                    url: e.url,
                });
                this.handlersByNavigationId.set(e.id, handler);
            } else if (e instanceof NavigationEnd || e instanceof NavigationCancel || e instanceof NavigationError) {
                const handler = this.handlersByNavigationId.get(e.id);
                if (handler) {
                    handler.done();
                    this.handlersByNavigationId.delete(e.id);
                }
            }
        });
    }
}
